const SELECTORS = {
	popup: '[data-ease-success-popup]',
	closeBtn: '[data-ease-success-close]',
	container: '[data-ease-total]',
};

const CLASSES = {
	active: 'active',
};

export class EaseUploadSuccess {
	constructor() {
		this.popup = document.querySelector(SELECTORS.popup);
		this.container = document.querySelector(SELECTORS.container);

		if (!this.popup || !this.container) {
			// eslint-disable-next-line no-constructor-return
			return;
		}

		this.totalDocs = parseInt(this.container.dataset.easeTotal, 10);
		this.alreadyComplete = this.container.dataset.easeAlreadyUploaded === 'true';
		this.uploadedCount = 0;
		this.hasShown = false;

		this.setup();
	}

	static init() {
		// eslint-disable-next-line
		new EaseUploadSuccess();
	}

	setup() {
		// Count how many are already non-missing by checking upload card statuses
		const uploadCards = this.container.querySelectorAll('.upload-document-card__status');
		uploadCards.forEach((card) => {
			const statusText = card.textContent.trim().toLowerCase();
			if (statusText !== '' && statusText !== 'missing') {
				this.uploadedCount += 1;
			}
		});

		// If all are already uploaded on page load, don't show popup
		if (this.alreadyComplete) {
			this.hasShown = true;
		}

		document.addEventListener('ease:document-uploaded', () => {
			this.uploadedCount += 1;
			if (this.uploadedCount >= this.totalDocs && !this.hasShown) {
				this.showPopup();
			}
		});

		const closeBtn = this.popup.querySelector(SELECTORS.closeBtn);
		if (closeBtn) {
			closeBtn.addEventListener('click', () => this.hidePopup());
		}
	}

	showPopup() {
		this.hasShown = true;
		this.popup.classList.add(CLASSES.active);

		setTimeout(() => {
			this.hidePopup();
		}, 10000);
	}

	hidePopup() {
		this.popup.classList.remove(CLASSES.active);
	}
}
